import { format } from '@if/core/date'
import type { TFunction } from '@if/core/i18n'
import { CustomBuydownPlan } from '@src/types/CustomBuydown'
import type { AxiosError } from 'axios'
import { PromoPlanErrorCode } from './promoPlanErrorCodes'

export const buildWindowOverlapMessage = (
  descriptor: { raw: unknown },
  otherPlan: CustomBuydownPlan | null | undefined,
  t: TFunction,
): { role: 'contextual'; message: string } | undefined => {
  const data = (descriptor.raw as AxiosError)?.response?.data
  const code = typeof data === 'string' ? data : undefined
  if (code !== PromoPlanErrorCode.WindowOverlap && code !== PromoPlanErrorCode.NewPlanOverlapsScheduledPlan) {
    return undefined
  }
  if (!otherPlan) {
    return { role: 'contextual', message: t('customBuydown.errors.windowOverlap') }
  }
  return {
    role: 'contextual',
    message: t('customBuydown.errors.windowEditOverlapsOtherPlan', {
      planCode: otherPlan.label,
      window: `${format(otherPlan.activeFrom, 'P')} – ${
        otherPlan.expiresOn ? format(otherPlan.expiresOn, 'P') : t('customBuydown.timeline.noEndDate')
      }`,
    }),
  }
}
